// Removes console.log from production environment
if (process.env.NODE_ENV !== 'development') {
    if (console.log) {
        console.log = () => {};
    }
    if (window.console.log) {
        window.console.log = () => {};
    }
}
